<template>
  <div class="home-page login-content" style="padding-top: 0;">
    <Header></Header>
		<div class="login login-send">
		    <div class="home-prize ac">
          <img style="width: 70%" src="../../static/images/login_tip.png" />
		    </div>
		  <div class="landing-page">
		    <div class="ac" style="position: relative;z-index: 10;">
		      <div class="login-list" style="width: 100%;">
		        <div class="disflex" style="background:none;box-shadow: none;justify-content: space-evenly;">
		          <div class="land-btn day_btn" v-if="showDaily" :class="{'active':type=='daily'}" @click="getType('daily')">
		            <div class="day" >
                  {{$t('Daily')}}
		            </div>
		          </div>
		          <div class="land-btn day_week" v-if="showWeekly"  :class="{'active':type=='weekly'}" @click="getType('weekly')">
		            <div class="week">
                  {{$t('Weekly')}}
		            </div>
		          </div>
		        </div>
            <div class="home-prize ac">
              <img style="width: 80%;margin-top: 50px" src="../../static/images/free_lessons.png" />
            </div>
            </div>
		      </div>
		    </div>
		    <div class="ac otp-b disflex mt50" style="justify-content: space-evenly;">
		      <div style="color: white" class="icon icon2 fw7" @click="push('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
		      <div style="color: white" class="icon icon2 fw7" @click="push('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
		    </div>
		  </div>
		</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',
        type:'daily',
        showDaily: true,  // 控制 daily 的显示
        showWeekly: true,  // 控制 weekly 的显示
      }
    },
	created(){
    console.log('created');
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.mobile){
      let that = this
      that.mobile = this.$route.query.mobile;
    }
    var type  = this.$route.query.type
    if (type === 'day'){
      this.showDaily = true
      this.showWeekly = false
    }else if(type === 'week'){
      this.showWeekly = true
      this.showDaily = false
    }else{
      this.showDaily = true
      this.showWeekly = true
    }
	},
  mounted(){
    console.log('mounted');
  },
    methods: {
      getType(type){
        this.type = type
        this.goLogin()
      },
      back(){
        this.$router.go(-1);
      },
      push(path){
        this.$router.push({path:path});
      },
		  goLogin(){
        let that = this
        let queryParams = this.$route.query;
        if(!that.mobile){
          //没有号码直接跳登录页面
          that.$router.push({path:'/login',query: {...queryParams,type:that.type}})
        }else{
          //有号码直接订阅登录
          that.$parent.loadModal(true);
          let mobile = this.mobile
          let type  = this.type
          delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
          delete queryParams.type; // 删除 type，避免 URL 里重复
          let queryString = Object.keys(queryParams).length
            ? '&' + Object.entries(queryParams)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&')
            : '';
          let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
          that.$api.get(url, {},r =>{
            that.$parent.returnCode(r,function(){
              that.$parent.loadModal(false);
              if (r.code == 1){
                localStorage.setItem('token',r.data.userinfo.token)
                localStorage.setItem('mobile',r.data.userinfo.mobile)
                localStorage.setItem('avatar',r.data.userinfo.avatar)
                that.$router.push('/');
              }else{
                that.$utils.alertText(r.msg,80, 3000);
              }
            });
          })
        }
		  },
	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/land.vue